(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section/assets/javascripts/casino-section-header.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section/assets/javascripts/casino-section-header.js');

'use strict';

const CasinoSectionHeader = _ref => {
  let ActionButtons = _ref.ActionButtons,
    title = _ref.title;
  return React.createElement("div", {
    className: "casino-section__header"
  }, React.createElement("h2", {
    className: "casino-section__header-title"
  }, title && title), React.createElement("div", {
    className: "casino-section__header-action-buttons"
  }, ActionButtons && React.createElement(ActionButtons, null)));
};
setGlobal('svs.components.casino_react.casinoSection.CasinoSectionHeader', CasinoSectionHeader);

 })(window);